jQuery(document).ready(function () {
  var servings = document.querySelector(
    ckdc.shoppingList.shoppingListServingsTagSelector
  );
  var addToBtn = document.querySelector(
    ckdc.shoppingList.shoppingListAddButtonTagSelector
  );
  var toastNotification = document.querySelector(
    ckdc.shoppingList.shoppingListToastNotificationTagSelector
  );

  window.dd = window.dd || {};

  if (addToBtn && toastNotification) {
    jQuery.getJSON(
      "/wp-content/themes/ckdc/src/js/fb/config.json",
      function (config) {
        window.dd.shoppingList = ShoppingList.use({
          language: ckdc.shoppingList.language,
          authToken: Cookies.get("auth"),
          recipeId: ckdc.shoppingList.recipeId,
          userId: ckdc.shoppingList.userId,
          isPremium: ckdc.shoppingList.isPremium,
          firebaseAPIKey: config.apiKey,
          firebaseProjectId: config.projectId,
          numIngredientsInRecipe: ckdc.shoppingList.numIngredientsInRecipe,
          $servings: servings,
          $addToBtn: addToBtn,
          $toastNotification: toastNotification,
          translations: {
            recipeHasBeenAdded:
              ckdc.shoppingList.translations.recipeHasBeenAdded,
          },
        });
      }
    );
  }
});
